module.exports = __webpack_public_path__ + "static/media/super-hit.b9f4f773.png";